import { type FC } from "react";
import { useWidget } from "../../contexts/useWidget";

const LogoIcon: FC = () => {
  const { brandInformation } = useWidget();

  return (
    brandInformation.logo ? (
      <img src={brandInformation.logo} alt="Logo" className="size-[30px] rounded-full object-contain" />
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        fill="none"
        className="size-[30px]"
      >
        <path d="M9.26 1.142A15.001 15.001 0 0 1 15 0v7.5A7.499 7.499 0 0 0 7.5 15H0A15.001 15.001 0 0 1 9.26 1.142Z" fill="#155EEF" />
        <path d="M0 15a15.001 15.001 0 0 0 28.858 5.74A15 15 0 0 0 30 15h-7.5a7.5 7.5 0 0 1-15 0H0ZM15 10.227A4.773 4.773 0 0 0 10.227 15h9.546A4.773 4.773 0 0 0 15 10.227Z" fill="#84ADFF" />
        <path d="M15 19.773A4.773 4.773 0 0 1 10.227 15h9.546A4.773 4.773 0 0 1 15 19.773Z" fill="#155EEF" />
      </svg>
    )
  );
};

export default LogoIcon;
